import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BonusSummary } from '../../../core/models';

/**
 * Bonus Summary Card Component
 * Displays an overview of total bonus, cashback, and available withdrawal amount
 * Used on bonus history page and potentially other dashboard views
 */
@Component({
  selector: 'app-bonus-summary-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './bonus-summary-card.component.html',
  styleUrl: './bonus-summary-card.component.scss'
})
export class BonusSummaryCardComponent {
  @Input() summary: BonusSummary | null = null;
  @Input() isLoading: boolean = false;
  @Input() showWithdrawButton: boolean = true;

  /**
   * Calculate total of bonus and cashback
   */
  get grandTotal(): number {
    if (!this.summary) return 0;
    return (this.summary.totalBonus || 0) + (this.summary.totalCashback || 0);
  }

  /**
   * Check if withdrawal is available
   */
  get canWithdraw(): boolean {
    return (this.summary?.availableForWithdrawal || 0) > 0;
  }

  /**
   * Emit withdrawal request event
   */
  onWithdrawClick(): void {
    if (this.canWithdraw) {
      // This will be handled by parent component
      // Parent should listen to this event and open withdrawal modal
    }
  }
}
